import React from "react";

import { useTranslation } from "react-i18next";

export default function WalletTag(props: {
	isWalletManuallyDisabled?: boolean;
}) {
	const { t } = useTranslation();

	if (!props.isWalletManuallyDisabled) {
		return null;
	}

	return (
		<span className="tag tag--tny tag--slip--disabled">
			<span className="tag--slip--disabled__label">
				{t("COMMON.DISABLED")}
			</span>
		</span>
	);
}
